export const WORK_CATEGORIES = [
  {
    value: 'white_collar',
    label: 'Office & professional jobs',
    description: 'IT, sales, accounts, HR, marketing, teaching and other office roles',
    examples: ['Software', 'Sales', 'Accounts', 'HR', 'Teacher', 'Designer'],
  },
  {
    value: 'blue_collar',
    label: 'Skilled work & services',
    description: 'Hands-on and field work — no resume needed, your profile is enough',
    examples: ['Driver', 'Delivery', 'Electrician', 'Security', 'Housekeeping', 'Cook', 'Plumber', 'Tailor'],
  },
];

export const JOB_TYPES = [
  { value: 'full_time', label: 'Full time' },
  { value: 'part_time', label: 'Part time' },
  { value: 'contract', label: 'Contract' },
  { value: 'gig', label: 'Gig / Daily work' },
];

export const SHIFTS = [
  { value: 'any', label: 'Any shift' },
  { value: 'day', label: 'Day shift' },
  { value: 'night', label: 'Night shift' },
  { value: 'rotational', label: 'Rotational' },
];

export const SALARY_PERIODS = [
  { value: 'yearly', label: 'Per year' },
  { value: 'monthly', label: 'Per month' },
  { value: 'daily', label: 'Per day' },
];

export const EDUCATION_LEVELS = [
  { value: '10th_pass', label: '10th pass' },
  { value: '12th_pass', label: '12th pass' },
  { value: 'iti', label: 'ITI' },
  { value: 'diploma', label: 'Diploma' },
  { value: 'graduate', label: 'Graduate' },
  { value: 'postgraduate', label: 'Postgraduate' },
  { value: 'doctorate', label: 'Doctorate' },
];

// Levels at or above this show degree/specialization fields
export const DEGREE_LEVELS = ['diploma', 'graduate', 'postgraduate', 'doctorate'];

export const ID_TYPES = [
  { value: 'aadhaar', label: 'Aadhaar' },
  { value: 'pan', label: 'PAN card' },
  { value: 'voter_id', label: 'Voter ID' },
  { value: 'driving_licence', label: 'Driving licence' },
];

export const GENDERS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
];

export const LANGUAGE_SUGGESTIONS = [
  'Hindi', 'English', 'Bengali', 'Marathi', 'Telugu', 'Tamil', 'Gujarati',
  'Kannada', 'Malayalam', 'Odia', 'Punjabi', 'Assamese', 'Urdu',
];

export const COMPLETENESS_WEIGHTS = {
  basic: 20,
  experience: 20,
  education: 15,
  skills: 15,
  languages: 10,
  preferences: 10,
  resume: 10,
};

export const SECTION_LABELS = {
  basic: 'Basic details',
  preferences: 'Career preferences',
  experience: 'Work experience',
  education: 'Education',
  skills: 'Skills',
  languages: 'Languages',
  certifications: 'Certifications',
  resume: 'Resume',
  identity: 'ID verification',
};
